import React from 'react';
import { Slider, Grid, Typography, Box } from '@mui/material';
import ReactInputMask from 'react-input-mask';
import Alert from '@mui/material/Alert';


function CompanyData({ sliderValue, employeer, addressEmployeer, marks, handleChangeEmployeer, handleChangeAddress, handleChangeSlider, activeErrorCNJ, errorCNJ, errorGeneric }) {

    return (
        <Grid style={styles.container}>
            <Grid>
                <Typography variant="h4" style={styles.firstTitle}>
                    Dados da empresa
                </Typography>
                <Typography variant="h6" style={styles.subTitle}>
                    Insira as informações da sua empresa.
                </Typography>
            </Grid>
            <Grid style={styles.gridInputs}>
                <Grid>
                    <Grid container spacing={3}>
                        {employeer.map(i => (
                            <Grid item xs={4}>
                                <Typography style={styles.titleInput} color={i.config.value ? 'gray' : 'black'}>{i.config.label}</Typography>
                                <ReactInputMask
                                    mask={i.config.mask}
                                    variant="outlined"
                                    type={i.config.type}
                                    style={styles.input}
                                    required
                                    id={i.config.id}
                                    name={i.config.name}
                                    placeholder={i.config.label}
                                    value={i.config.value}
                                    onChange={handleChangeEmployeer}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={styles.boxSlider}>
                <Typography id="num-funcionarios-slider" gutterBottom style={styles.titleSlider} >
                    Número de funcionários
                </Typography>
                <Slider
                    name='employeesRange'
                    aria-label="Always visible"
                    defaultValue={sliderValue}
                    min={1}
                    step={1}
                    max={100}
                    value={sliderValue}
                    onChange={handleChangeSlider}
                    valueLabelDisplay="auto"
                    marks={marks}
                />
            </Box>
            <Grid style={styles.gridAddress}>
                <Grid>
                    <Grid container spacing={3}>
                        {addressEmployeer.map(i => (
                            <Grid item xs={4}>
                                <Typography style={styles.titleAddress} color={i.config.value ? 'gray' : 'black'}>{i.config.label}</Typography>
                                <ReactInputMask
                                    mask={i.config.mask}
                                    variant="outlined"
                                    type={i.config.type}
                                    style={styles.input}
                                    required
                                    id={i.config.id}
                                    name={i.config.name}
                                    placeholder={i.config.label}
                                    value={i.config.value}
                                    onChange={handleChangeAddress}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            {activeErrorCNJ ? (
                <Alert severity="warning" style={{ marginTop: '2em' }}>{errorCNJ}</Alert>
            ) : (
                errorGeneric === 'Esse cnpj já está cadastrado. Utilize a página de login para acessar sua empresa ou entre em contato com o suporte!' ? (
                    <Alert severity="warning" style={{ marginTop: '2em' }}>
                        <Typography>
                            Esse cnpj já está cadastrado. Utilize a página de <a href='https://app.puntu.com.br/'>login</a>  para acessar sua empresa ou entre em contato com o <a href="https://api.whatsapp.com/send/?phone=5561996894936&text&type=phone_number&app_absent=0">suporte</a>.</Typography>
                    </Alert>
                ) : (
                    ''
                )
            )
            }
        </Grid >
    )
}

export default CompanyData;

const styles = ({
    container: {
        justifyContent: 'flex-start',
        display: 'flex',
        padding: 50,
        flexDirection: 'column'
    },
    firstTitle: {
        fontFamily: 'Montserrat',
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '30px'
    },
    subTitle: {
        fontFamily: 'Montserrat',
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '15px'
    },
    gridInputs: {
        paddingTop: 60
    },
    titleInput: {
        textAlign: 'start',
        fontFamily: 'montserrat',
        fontSize: '12px',
        fontWeight: 'bold'
    },
    input: {
        width: '100%',
        border: "none",
        outline: "none",
        padding: '0px',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: '600',
        height: '20px',
        '::placeholder': { color: '#FFFFF' },
    },
    boxSlider: {
        width: '100%',
        paddingTop: '35px'
    },
    titleSlider: {
        textAlign: 'left'
    },
    gridAddress: {
        paddingTop: '35px'
    },
    titleAddress: {
        textAlign: 'start'
    }
})
